import Cookie from "js-cookie";

export default {
    methods: {
        getUrlPhoto(link) {
            let trimCookie = Cookie.get("access_token") ? Cookie.get("access_token").replace(/[А-Яа-я]/gi, "") : "";
            return link + '?access_token=' + `${trimCookie}`
        }
    }
}
